exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".saved-search[data-v-38e354c5]{padding:5px 5px 0}.saved-view-link-col[data-v-38e354c5]{padding-left:unset}.saved-view-link[data-v-38e354c5]{text-decoration:none}.af-icons-action-overflow[data-v-38e354c5]{font-size:24px}.form[data-v-38e354c5]{margin-bottom:10px}", ""]);

// exports
